(function () {
  function formatMoney(cents) {
    return '$' + Math.round(cents / 100);
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-fm-gift-kit]').forEach(function (root) {
      var img = root.querySelector('[id^="FmGiftKitDryerImage-"]');
      if (img && variant.featured_image && variant.featured_image.src) {
        img.src = variant.featured_image.src;
        img.removeAttribute('srcset');
      }

      var hasCompare = !!(variant.compare_at_price && variant.compare_at_price > variant.price);

      var compareEls = root.querySelectorAll('[id^="FmGiftKitCompare-"], [id^="FmGiftKitRowCompare-"]');
      compareEls.forEach(function (el) {
        el.style.display = hasCompare ? '' : 'none';
        if (hasCompare) el.textContent = formatMoney(variant.compare_at_price);
      });

      var finalEls = root.querySelectorAll('[id^="FmGiftKitFinal-"], [id^="FmGiftKitRowFinal-"]');
      finalEls.forEach(function (el) {
        el.textContent = formatMoney(variant.price);
      });

      var badge = root.querySelector('[id^="FmGiftKitBadge-"]');
      if (badge) {
        var template = badge.getAttribute('data-badge-template') || '';
        var giftValue = badge.getAttribute('data-gift-value') || '0';
        var percent = hasCompare
          ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
          : 0;
        badge.textContent = template.replace('[percent]', percent).replace('[value]', giftValue);
      }
    });
  });

  function initAccordion(details) {
    var summary = details.querySelector(':scope > .fm-gift-kit__summary');
    var rows = details.querySelector(':scope > .fm-gift-kit__rows');
    if (!summary || !rows) return;

    if (details.open) {
      rows.style.height = 'auto';
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.open) {
        var startHeight = rows.scrollHeight;
        rows.style.height = startHeight + 'px';
        requestAnimationFrame(function () {
          rows.style.height = '0px';
        });
        rows.addEventListener(
          'transitionend',
          function handler() {
            details.open = false;
            rows.style.height = '';
            rows.removeEventListener('transitionend', handler);
          },
          { once: true }
        );
      } else {
        details.open = true;
        var endHeight = rows.scrollHeight;
        rows.style.height = '0px';
        requestAnimationFrame(function () {
          rows.style.height = endHeight + 'px';
        });
        rows.addEventListener(
          'transitionend',
          function handler() {
            rows.style.height = 'auto';
            rows.removeEventListener('transitionend', handler);
          },
          { once: true }
        );
      }
    });
  }

  document.querySelectorAll('.fm-gift-kit__details').forEach(initAccordion);
})();
